/* Vokshus motion — Spar-beloppen räknas upp när de kommer i bild.
 * GSAP borttagen 2026-08-18 (116 KB på varje sidvisning för en räknare);
 * samma effekt med IntersectionObserver + requestAnimationFrame.
 * Regler: allt är rent kosmetiskt. Utan JS, utan IntersectionObserver eller
 * med prefers-reduced-motion visas sidan komplett och statisk.
 * Kort-reveals sköts av vokshus-reveal.js (CSS), INTE här.
 * Rör ALDRIG köpmekanik (forms, [data-vk-*]-hooks lämnas orörda). */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function animate(el, original, prefix, target, suffix) {
    var start = Math.max(0, Math.round(target * 0.35));
    var duration = 800;
    var t0 = null;
    function tick(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / duration);
      var eased = 1 - (1 - p) * (1 - p); // power1.out-motsvarighet
      el.textContent = prefix + Math.round(start + (target - start) * eased) + suffix;
      if (p < 1) {
        window.requestAnimationFrame(tick);
      } else {
        el.textContent = original; // slutvärdet exakt som det stod i DOM
      }
    }
    window.requestAnimationFrame(tick);
  }

  function initCounters() {
    var els = document.querySelectorAll('.vk-pgrid__save');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        // Texten står färdig i DOM utan JS; misslyckas något skrivs slutvärdet in direkt.
        var original = el.textContent;
        var m = original.match(/^(\D*?)(\d[\d\s ]*)(\s*kr\b.*)$/);
        if (!m) return;
        var target = parseInt(m[2].replace(/[\s ]/g, ''), 10);
        if (!target || target > 99999) return;
        animate(el, original, m[1], target, m[3]);
      });
    }, { rootMargin: '0px 0px -8% 0px' }); // ~ScrollTriggers "top 92%"
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCounters);
  } else {
    initCounters();
  }
})();
